import React, { useEffect, useState } from "react";
import { Backdrop, Button, FormFieldSet, LogoLoader, Modal, showToast, SmartTooltip, TableAdv } from "../../../../components";
import { mapTableRows } from "../../../../utils";
import AddCompanyModal from "../Modals/AddCompanyModal";
import { useDispatch, useSelector } from "react-redux";
import { formatWords2 } from "../../../../utils/stringUtils";
import { fetchCompanyLeadsStart, removeCompanyFromState } from "../../../../redux/slices/bdmjobs/bdmjobsSlice";
import { deleteCompany, updateLeadCompany } from "../../../../redux/slices/bdmjobs/bdmjobsApi";
import { usePagination } from "../../../../hooks";
import { totalCountStart } from "../../../../redux/slices/totalCount/totalCountSlice";
import EditCompanyModal from "../Modals/EditCompanyModal";

const Configuration = () => {
    const [openCompanyModal, setOpenCompanyModal] = useState(false);
    const [editCompanyModal, setEditCompanyModal] = useState(false);
    const [showDeleteAlert, setShowDeleteAlert] = useState(false);
    const [deleteLeadCompany, setDeleteLeadCompany] = useState(null);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [visibilityModal, setVisibilityModal] = useState(false);
    const dispatch = useDispatch();
    const companyLeadsState = useSelector((state) => state?.bdmJobs?.companyLeads);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [selectedRows,setSelectedRows]=useState([])
    const companyLeads = companyLeadsState?.data || [];
    const loading = companyLeadsState?.loading || false;
    const { user } = useSelector((state) => state.auth);
    const { value } = useSelector((state) => state.totalCount); 
    const { page, limit, setPage, handleLimitChange } = usePagination(
        10,
        (newPage, newLimit) => { }
    );
    const totalCount = value?.leadCompanyCount?.data || 0;
    const getValidUrl = (url) => {
        if (!url) return "#";
        if (url.startsWith("http://") || url.startsWith("https://")) {
            return url;
        }
        return `https://${url}`;
    };


    const columns = [
        {
            key: "companyName",
            label: "Company Name",
            width: "min-w-[250px]! max-w-[300px]!",
            render: (row) => (
            <SmartTooltip
            description={row?.companyName}
            size="xs"
            color="black"
            noicon
            tooltipPosition="bottom"
            portal={true}
            >
            <div className="line-clamp-1">{row?.companyName}</div>
            </SmartTooltip>
        ),
        },
        {
            key: "url",
            label: "LinkedIn URL",
            render: (row) => (
                <div className="flex-1 flex items-center gap-2">
                    <a
                        href={getValidUrl(row?.url)}
                        target="_blank"
                        className="text-info underline"
                        rel="noreferrer"
                    >
                        Click
                    </a>
                </div>
            ),
        },
        {
            key: "isEnabled",
            label: "Is Enabled",
            render: (row) => (
                // <Button
                //     type="icon"
                //     color="black"
                //     icon={"visibility"}
                //     variant="text"
                //     size="sm"
                // />
                <FormFieldSet
                    isChecked={row?.isEnabled}
                    type="toggle"
                    onChange={(checked) => handleToggleCompany(row, checked)}
                    noTitle
                    size="sm"
                />
            )
        },
        {
            key: "addedBy",
            label: "Added By",
        },
        {
            key: "status",
            label: "Status",
            render: (row) => (
                <div>
                    {(user?.data?.role?.uiid === 1 || row?.addedByUiid === user?.data?.uiid) && (
                        <SmartTooltip
                            description={row.status === 1 ? "Deactivate" : "Activate"}
                            noicon
                        >
                            <FormFieldSet
                                type="toggle"
                                size="sm"
                                noTitle
                                isChecked={row.status === 1}
                                onChange={() => handleStatusChange(row)}
                            />
                        </SmartTooltip>
                    )}
                </div>
            )
        },
        {
            key: "",
            label: "Action",
            render: (row) => (
                <div className="flex-1 flex items-center gap-2">
                    {(user?.data?.role?.uiid === 1 || row?.addedByUiid === user?.data?.uiid) && (
                        <SmartTooltip description={"Edit"} noicon>
                            <Button
                                type="icon"
                                variant="text"
                                icon="edit_square"
                                size="sm"
                                color="black"
                                onClick={() => {
                                    setSelectedCompany(row);
                                    setEditCompanyModal(true);
                                }}
                            />
                        </SmartTooltip>
                    )}
                    {/* {(user?.data?.role?.uiid === 1 || row?.addedByUiid === user?.data?.uiid) && (
                        <SmartTooltip description={"Delete"} noicon>
                            <Button
                                type="icon"
                                variant="text"
                                icon="delete"
                                color="black"
                                size="sm"
                                onClick={() => {
                                    setDeleteLeadCompany(row);
                                    setShowDeleteAlert(true);
                                }}
                            />
                        </SmartTooltip>
                    )} */}
                    {user?.data?.role?.uiid === 1 && (
                        <SmartTooltip description={"Visibility Settings"} noicon>
                            <Button
                                type="icon"
                                variant="text"
                                icon="settings"
                                size="sm"
                                color="black"
                                onClick={() => {
                                    setSelectedCompany(row);
                                    setVisibilityModal(true);
                                }}
                            />
                        </SmartTooltip>
                    )}

                </div>
            )
        },
    ];
    const isAdmin = user?.data?.role?.uiid === 1;

    const companyListFilter = isAdmin
        ? {}
        : {
            fil: {
                allowOthersToSee: {
                    type: "NONE",
                    value: true,
                },
            },
        };

    const companyCountFilter = isAdmin
        ? {}
        : {
            allowOthersToSee: {
                type: "NONE",
                value: true,
            },
        };

    const handleToggleCompany = async (row, checked) => {
        try {
            const res = await updateLeadCompany({
                coll: "LeadCompany",
                uiid: row.id,
                payload: [
                    {
                        type: "SET",
                        value: {
                            isEnabled: checked,
                        },
                    },
                ],
            });

            if (res?.data) {
                showToast(`Company ${checked ? "enabled" : "disabled"} successfully`, "success");
                dispatch(
                    fetchCompanyLeadsStart({
                        coll: "LeadCompany",
                        lim: limit,
                        pg: page,
                        ret: "uiid name linkedInUrl isEnabled status addedBy allowOthersToSee",
                        extret: "uiid firstName",
                        sort: { addedOn: -1 },
                        ...companyListFilter,
                    })
                );
            } else {
                showToast("Failed to update company.")
            }
        } catch (error) {
            showToast(
                error?.response?.data?.message || "Failed to update company status",
                "error"
            );
        }
    };

    const handleDeleteCompany = async () => {
        if (!deleteLeadCompany?.id) {
            showToast("ID not found!","error");
            return;
        }

        try {
            setDeleteLoading(true);
            const res = await deleteCompany({
                coll: "LeadCompany",
                uiid: deleteLeadCompany.id,
            });

            if (res?.data) {
                showToast("Company deleted successfully", "success");
                dispatch(
                    totalCountStart({
                        collection: "leadcompanys",
                        coll: "LeadCompany",
                        tname: "leadCompanyCount",
                        app: "ats",
                        filters: companyCountFilter,
                    })
                );
                dispatch(
                    fetchCompanyLeadsStart({
                        coll: "LeadCompany",
                        lim: limit,
                        pg: page,
                        ret: "uiid name linkedInUrl isEnabled addedBy status allowOthersToSee",
                        extret: "uiid firstName",
                        sort: { addedOn: -1 },
                        ...companyListFilter,
                    })
                );
                dispatch(removeCompanyFromState(deleteLeadCompany.id));
            } else {
                showToast("Failed to delete company", "error");
            }
        } catch (error) {
            showToast(
                error?.response?.data?.message || "Failed to delete company",
                "error"
            );
        } finally {
            setShowDeleteAlert(false);
            setDeleteLeadCompany(null);
            setDeleteLoading(false);
        }
    };
    const handleStatusChange = async (row) => {
        const newStatus = row.status === 1 ? 2 : 1;

        try {
            await updateLeadCompany({
                coll: "LeadCompany",
                uiid: row.id,
                payload: [
                    {
                        type: "SET",
                        value: { status: newStatus },
                    },
                ],
            });

            showToast(
                `Company ${newStatus === 1 ? "activated" : "deactivated"} successfully`,
                "success"
            );

            dispatch(fetchCompanyLeadsStart({
                coll: "LeadCompany",
                lim: limit,
                pg: page,
                ret: "uiid name linkedInUrl isEnabled status addedBy allowOthersToSee",
                extret: "uiid firstName",
                sort: { addedOn: -1 },
                ...companyListFilter,
            }));
        } catch (err) {
            showToast("Failed to update company status", "error");
        }
    };


    const rows = companyLeads.map((item) => ({
        id: item?.uiid || null,
        companyName: formatWords2(item?.name || ""),
        url: item?.linkedInUrl || "-",
        isEnabled: item?.isEnabled,
        addedBy: formatWords2(item?.addedBy?.firstName || "-"),
        allowOthersToSee: item?.allowOthersToSee,
        addedByUiid: item?.addedBy?.uiid || null,
        status: item?.status || 1,
    }));
    const mappedRows = mapTableRows(
        rows,
        columns
    );

    useEffect(() => {
        dispatch(
            totalCountStart({
                collection: "leadcompanys",
                coll: "LeadCompany",
                tname: "leadCompanyCount",
                app: "ats",
                filters: companyCountFilter,
            })
        );
        dispatch(fetchCompanyLeadsStart({
            coll: "LeadCompany",
            lim: limit,
            pg: page,
            ret: "uiid name linkedInUrl isEnabled addedBy allowOthersToSee status",
            extret: "uiid firstName",
            sort: { addedOn: -1 },
            ...companyListFilter,
        }));
    }, [dispatch, limit, page]);

    return (
        <div className="flex-1 flex overflow-auto">
            <TableAdv
                showCheckbox
                columns={columns}
                rows={mappedRows}
                serverPagination={true}
                totalCount={totalCount}
                onSelectionChange={setSelectedRows}
                defaultSelectedRows={selectedRows}
                page={page}
                limit={limit}
                onPageChange={setPage}
                onLimitChange={handleLimitChange}
                info={"info"}
                tdClassName="!py-3"
                toolbarRight={{
                    search: true,
                    filter: true,
                    add: [

                        {
                            component: (
                                <>
                                    <Button
                                        title="Add Company"
                                        size="md"
                                        icon={"add"}
                                        onClick={() => setOpenCompanyModal(true)}
                                    />
                                </>
                            ),
                        },
                    ],
                }}
            />
            <Modal
                isOpen={openCompanyModal}
                onClose={() => setOpenCompanyModal(false)}
                title={"Add Company"}
                titleColor={"primary"}
                width="max-w-5xl"
            >
                <AddCompanyModal
                    onCancel={() => setOpenCompanyModal(false)}
                    onSuccess={() => {
                        dispatch(
                            totalCountStart({
                                collection: "leadcompanys",
                                coll: "LeadCompany",
                                tname: "leadCompanyCount",
                                app: "ats",
                                filters: companyCountFilter,
                            })
                        );
                        dispatch(
                            fetchCompanyLeadsStart({
                                coll: "LeadCompany",
                                lim: limit,
                                pg: page,
                                ret: "uiid name linkedInUrl isEnabled addedBy allowOthersToSee status",
                                extret: "uiid firstName",
                                sort: { addedOn: -1 },
                                ...companyListFilter,
                            })
                        )
                    }}
                />
            </Modal>
            <Modal
                isOpen={editCompanyModal}
                onClose={() => {
                    setEditCompanyModal(false);
                    setSelectedCompany(null);
                }}
                title={"Edit Company"}
                titleColor={"primary"}
                width="max-w-5xl"
            >
                <EditCompanyModal
                    companyData={selectedCompany}
                    onCancel={() => setEditCompanyModal(false)}
                    onSuccess={() => {
                        setSelectedCompany(null);
                        dispatch(
                            totalCountStart({
                                collection: "leadcompanys",
                                coll: "LeadCompany",
                                tname: "leadCompanyCount",
                                app: "ats",
                                filters: companyCountFilter,
                            })
                        );
                        dispatch(
                            fetchCompanyLeadsStart({
                                coll: "LeadCompany",
                                lim: limit,
                                pg: page,
                                ret: "uiid name linkedInUrl isEnabled addedBy allowOthersToSee status",
                                extret: "uiid firstName",
                                sort: { addedOn: -1 },
                                ...companyListFilter,
                            })
                        )
                    }}
                />
            </Modal>
            <Modal
                showCloseButton={false}
                isOpen={showDeleteAlert}
                onClose={() => {
                    setShowDeleteAlert(false);
                    setDeleteLeadCompany(null);
                }}
            >
                <div className="text-center my-3">
                    <p>Are you sure you want to delete</p>
                    <p className="text-info">"{deleteLeadCompany?.companyName || "-"}"</p>
                    <p>from my Companies list?</p>
                    <div className="flex justify-center items-center gap-3 mt-8">
                        <Button
                            title="Cancel"
                            variant="outlined"
                            color="black"
                            onClick={() => {
                                setShowDeleteAlert(false);
                                setDeleteLeadCompany(null);
                            }}
                        />
                        <Button
                            title="Delete"
                            onClick={handleDeleteCompany}
                        />
                    </div>
                </div>
                <Backdrop isOpen={deleteLoading}>
                    <LogoLoader />
                </Backdrop>
            </Modal>
            <Modal
                isOpen={visibilityModal}
                onClose={() => {
                    setVisibilityModal(false);
                    setSelectedCompany(null);
                }}
                title="Company Visibility"
                titleColor="primary"
                width="max-w-md"
            >
                <div className="p-6 space-y-6">
                    <p className="text-sm text-gray-600">
                        Allow other users to see this company
                    </p>

                    <FormFieldSet
                        type="toggle"
                        title="Visible to others"
                        isChecked={selectedCompany?.allowOthersToSee}
                        onChange={async (checked) => {
                            try {
                                await updateLeadCompany({
                                    coll: "LeadCompany",
                                    uiid: selectedCompany.id,
                                    payload: [
                                        {
                                            type: "SET",
                                            value: {
                                                allowOthersToSee: checked,
                                            },
                                        },
                                    ],
                                });

                                showToast(
                                    `Company is now ${checked ? "visible" : "restricted"}`,
                                    "success"
                                );

                                setVisibilityModal(false);
                                setSelectedCompany(null);

                                dispatch(fetchCompanyLeadsStart({
                                    coll: "LeadCompany",
                                    lim: limit,
                                    pg: page,
                                    ret: "uiid name linkedInUrl isEnabled addedBy allowOthersToSee status",
                                    extret: "uiid firstName",
                                    sort: { addedOn: -1 },
                                    ...companyListFilter,
                                }));
                            } catch (error) {
                                showToast("Failed to update visibility", "error");
                            }
                        }}
                    />
                </div>
            </Modal>

            <Backdrop isOpen={loading || deleteLoading}>
                <LogoLoader />
            </Backdrop>
        </div>
    );
};

export default Configuration;
